import React from "react";
import Page from "../components/Page";
import { Panel } from "../components/Panels";
import { Card } from "../components/Card";
import SubscribeFrm from "../components/SubscribeFrm";

const Home = () => (
  <Page title="Welcome">
    <div
      className="row align-items-center pb-md-5"
      style={{ padding: "3rem 0" }}
    >
      <div className="col">
        <h1>Build AI into any application</h1>
        <p className="mt-md-3 pb-4" style={{ fontSize: "1.3rem" }}>
          A diverse suite of endpoints for data scientists, developers, and
          engineers.
        </p>
        <button className="btn-lg btn-primary mt-md-2 mr-md-3 mb-3 fw-sm">
          Get Started
        </button>
        <button className="btn-lg btn-red mt-md-2 fw-sm">Docs</button>
      </div>
      <div
        id="lego_blocks"
        className="col-md-8 d-flex flex-md justify-content-center"
      >
        <div className="div" style={{ position: "relative" }}>
          <img src="/images/lego_blocks_.png" alt="" id="orange" />
          <img src="/images/lego_blocks_blue.png" alt="" id="blue" />
          <img
            src="/images/lego_blocks_yellow.png"
            alt=""
            id="yellow"
            width="157px"
            height="121px"
          />
          <img
            src="/images/lego_blocks_green.png"
            alt=""
            id="green"
            width="157px"
            height="121px"
          />
        </div>
      </div>
    </div>
    <div className="row mt-5 mb-md-5">
      <div className="col">
        <span className="subtitle txt-red mb-md-5">
          Available AI/ML Endpoints
        </span>
        <h1>Some of the solutions we offer</h1>
      </div>
    </div>

    <Panel
      subtitle="/understand, /match, and /clean"
      header="Clean data and provide key insights"
      text="Harness the power of NLP where the business needs it - ask any question - get back clean data, understand that question, and match that question to key data"
      link="/learn more"
    />
    <Panel
      subtitle="/answer"
      header="Answer a financial question by mining Big Data"
      text="Get the answer to pressing financial questions by simple inputting natural language.  Useful for financial insights, data mining, and visualizations."
      link="/learn more"
      color="yellow"
    />
    <Panel
      subtitle="/portfolio and /backtest"
      header="Input stock names or tickers and get key data"
      text="Using NLP, /portfolio and /backtest are key endpoints for quants and portfolio managers alike, build and backtest your strategy like a pro"
      link="/learn more"
      color="green"
    />
    <Panel
      subtitle="/sentiment"
      header="Analyze sentiment and get key actions from text"
      text="Using NLP, understand the sentiment of a key piece of text, a consumer comment, an article, or an earnings report. Get key actions and insights."
      link="/learn more"
      color="blue"
    />

    <div className="row section pb-5">
      <div className="col text-center">
        <span className="subtitle txt-green">Get Started in minutes</span>
        <h1>
          Responses compatible with <br className="visible-md" />
          every modern data stack
        </h1>
      </div>
    </div>

    <div className="row d-none d-sm-block pt-5 pb-5">
      <div className="col d-flex justify-content-center">
        <img
          src="/images/stack_product_list.png"
          alt=""
          style={{ width: "75%" }}
        />
      </div>
    </div>

    <div className="row d-none d-sm-block pt-5 pb-5">
      <div className="col d-flex justify-content-center">
        <img src="/images/terminal.png" alt="" style={{ width: "60%" }} />
      </div>
    </div>

    <div className="row section">
      <div className="container panels pad text-center">
        <div className="row align-items-center justify-content-center">
          <div className="col col-md-auto pb-3 pb-md-0">
            <h1>Start building today</h1>
          </div>
          <div className="col-md-auto">
            {" "}
            <div className="btn-lg btn-primary">Get API</div>
          </div>
        </div>
      </div>
    </div>

    <div className="row section mb-md-3">
      <div className="col">
        <span className="subtitle txt-yellow mb-md-5">Built with Spawner</span>
        <h1>A range of possibilities</h1>
      </div>
    </div>

    <div className="row pb-5">
      <div className="container panels p-0">
        <div className="row d-flex d-block-md align-items-center">
          <div className="col m-3 m-md-5 d-flex flex-column justify-content-between">
            <div>
              <h1>AskWST</h1>
              <p>
                The combined knowledge of Wall Street at your fingertips.&nbsp;
                <span className="txt-light-gray">
                  Introducing AI that closes the gap between shots in the dark
                  and real financial research.
                </span>
              </p>
            </div>
            <a
              href="https://askwst.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit Site &nbsp;>
            </a>
          </div>
          <div className="col-12 col-md-6" id="sample_work">
            <img src="/images/app_thumbnail.png" width="100%" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div className="row section mb-md-5">
      <div className="col">
        <span className="subtitle txt-blue mb-md-5">
          Deploy an application instantly
        </span>
        <h1>Try one of our templates!</h1>
      </div>
    </div>

    <div className="row row-cols-1 row-cols-md-2 card-deck">
      <div className="col p-3">
        <Card
          title="Filter queries for key phrases"
          text="Use this template for quickly using all sorts of available NLP from the Spawner API. "
          imgSRC="/images/template1.svg"
          bg="var(--blue-color)"
          url="/"
        >
          <img src="/images/logo_shiny.png" alt="" />
          <img src="/images/logo_R.png" alt="" />
        </Card>
      </div>

      <div className="col p-3">
        <Card
          title="Mine for financial data"
          text="Try this HTML/CSS rooted template to get started with insights into any financial question using NLP! "
          imgSRC="/images/template2.svg"
          bg="var(--yellow-color)"
          url="/"
        >
          <img src="/images/logo_html5.png" alt="" />
          <img src="/images/logo_python.png" alt="" />
        </Card>
      </div>

      <div className="col p-3">
        <Card
          title="Document Scan"
          text="Have an image, PDF, or other  file type you need to process? Use Object Detection to extract the value."
          imgSRC="/images/template3.svg"
          bg="var(--red-color)"
          url="/"
        >
          <img src="/images/logo_crown.png" alt="" />
          <img src="/images/logo_python.png" alt="" />
        </Card>
      </div>

      <div className="col p-3">
        <Card
          title="Your solution here"
          text="Have a problem you want solved? Or maybe you’ve already built a deployable template? Yours could go here."
          imgSRC="/images/template4.svg"
          url="/"
        />
      </div>
    </div>

    <div className="row section pb-5">
      <div className="container panels pb-0">
        <div className="row justify-content-center text-center pb-5">
          <div className="col col-md-auto">
            <h2>
              Our team is here <br className="visible-md" />
              <span className="txt-green">to support you.</span>
            </h2>
            <p className="pt-5">
              <a href="/team" className="btn btn-primary d-block d-md-inline">
                Meet us
              </a>
            </p>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col col-md-8">
            <img src="/images/team_member.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div className="row section pb-5">
      <div className="container">
        <div className="row align-items-center text-center pb-3">
          <div className="col">
            <span className="subtitle txt-blue pb-5">Newsletter</span>
            <h1 className="pb-5">
              Stay on top of <br className="visible-md" />
              industry-leading AI
            </h1>
            <SubscribeFrm />
          </div>
        </div>
      </div>
    </div>
  </Page>
);

export default Home;
